import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { HeaderOneComponent } from '../shared/header/header-one/header-one.component';
import { PeopleflowFooterComponent } from '../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [RouterModule, CommonModule, HeaderOneComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AdminComponent {
  [key: string]: any;
  constructor() {
  }


}
